/**
 * Текст и ссылка, которыми делится пользователь.
 *
 * Формулировка нейтральная по роду: одно и то же сообщение отправляют
 * разные люди, и «я создала» подошло бы не каждому.
 */
export function shareText(collectionTitle: string): string {
  return `Мой портрет в стиле ${collectionTitle} ✨ Попробуй создать свой.`;
}

/**
 * Ссылка-приглашение.
 *
 * Формат `?ref=CODE` разбирает captureReferralCode при загрузке. Без кода
 * возвращается обычная ссылка на приложение: подставлять пустой параметр
 * незачем, а «ref=» без значения выглядел бы как сломанное приглашение.
 */
export function referralLink(origin: string, referralCode?: string | undefined): string {
  const base = origin.replace(/\/+$/, '');

  return referralCode ? `${base}/?ref=${referralCode}` : `${base}/`;
}
